import * as $runtime from "../runtime.js";
import * as App$dSelector from "../App.Selector/index.js";
import * as Control$dMonad$dFree from "../Control.Monad.Free/index.js";
import * as Control$dMonad$dMaybe$dTrans from "../Control.Monad.Maybe.Trans/index.js";
import * as DOM$dHTML$dIndexed$dInputType from "../DOM.HTML.Indexed.InputType/index.js";
import * as DOM$dHTML$dIndexed$dStepValue from "../DOM.HTML.Indexed.StepValue/index.js";
import * as Data$dCatList from "../Data.CatList/index.js";
import * as Data$dCatQueue from "../Data.CatQueue/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Halogen$dComponent from "../Halogen.Component/index.js";
import * as Halogen$dHTML from "../Halogen.HTML/index.js";
import * as Halogen$dHTML$dEvents from "../Halogen.HTML.Events/index.js";
import * as Halogen$dHTML$dProperties from "../Halogen.HTML.Properties/index.js";
import * as Halogen$dQuery from "../Halogen.Query/index.js";
import * as Halogen$dQuery$dHalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen$dQuery$dInput from "../Halogen.Query.Input/index.js";
import * as Halogen$dVDom$dDOM$dProp from "../Halogen.VDom.DOM.Prop/index.js";
import * as Halogen$dVDom$dTypes from "../Halogen.VDom.Types/index.js";
import * as TcgCalculator$dTypes from "../TcgCalculator.Types/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Web$dEvent$dEvent from "../Web.Event.Event/index.js";
import * as Web$dHTML$dHTMLInputElement from "../Web.HTML.HTMLInputElement/index.js";
import * as Web$dInternal$dFFI from "../Web.Internal.FFI/index.js";
const $Action = (tag, _1) => ({tag, _1});
const $Output = () => ({tag: "Updated"});
const $Query = (tag, _1, _2) => ({tag, _1, _2});
const value = /* #__PURE__ */ Halogen$dVDom$dDOM$dProp.Property("value");
const selectorIsSymbol = {reflectSymbol: () => "selector"};
const slot = /* #__PURE__ */ Halogen$dHTML.slot()(selectorIsSymbol)(Data$dOrd.ordUnit);
const component1 = /* #__PURE__ */ App$dSelector.component(Data$dUUID.eqUUID);
const type_ = /* #__PURE__ */ (() => {
  const $0 = Halogen$dVDom$dDOM$dProp.Property("type");
  return x => $0(DOM$dHTML$dIndexed$dInputType.renderInputType(x));
})();
const mempty = /* #__PURE__ */ (() => Data$dSet.monoidSet(Data$dUUID.ordUUID).mempty)();
const sumBy = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap((() => {
  const semigroupAdditive1 = {append: v => v1 => v + v1 | 0};
  return {mempty: 0, Semigroup0: () => semigroupAdditive1};
})()))();
const min = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v === "LT") { return x; }
  if (v === "EQ") { return x; }
  if (v === "GT") { return y; }
  $runtime.fail();
};
const clamp = low => hi => x => {
  const v = Data$dOrd.ordInt.compare(low)(x);
  const $0 = (() => {
    if (v === "LT") { return x; }
    if (v === "EQ") { return low; }
    if (v === "GT") { return low; }
    $runtime.fail();
  })();
  const v$1 = Data$dOrd.ordInt.compare(hi)($0);
  if (v$1 === "LT") { return hi; }
  if (v$1 === "EQ") { return hi; }
  if (v$1 === "GT") { return $0; }
  $runtime.fail();
};
const fromFoldable = /* #__PURE__ */ Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Data$dUUID.ordUUID)(a)()(m))(Data$dMap$dInternal.Leaf);
const gets = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dMaybe$dTrans.monadStateMaybeT(Halogen$dQuery$dHalogenM.monadStateHalogenM);
  return f => $0.state(s => Data$dTuple.$Tuple(f(s), s));
})();
const member = k => {
  const go = go$a0$copy => {
    let go$a0 = go$a0$copy, go$c = true, go$r;
    while (go$c) {
      const v = go$a0;
      if (v.tag === "Leaf") {
        go$c = false;
        go$r = false;
        continue;
      }
      if (v.tag === "Node") {
        const v1 = Data$dOrd.ordString.compare(k)(v._3);
        if (v1 === "LT") {
          go$a0 = v._5;
          continue;
        }
        if (v1 === "GT") {
          go$a0 = v._6;
          continue;
        }
        if (v1 === "EQ") {
          go$c = false;
          go$r = true;
          continue;
        }
      }
      $runtime.fail();
    }
    return go$r;
  };
  return go;
};
const tell = /* #__PURE__ */ Halogen$dQuery.tell()(selectorIsSymbol)(Data$dOrd.ordUnit);
const $$get = /* #__PURE__ */ Control$dMonad$dFree.$Free(
  /* #__PURE__ */ Control$dMonad$dFree.$FreeView(
    "Bind",
    /* #__PURE__ */ Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s, s)),
    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
  ),
  Data$dCatList.CatNil
);
const foldMap1 = /* #__PURE__ */ (() => {
  const mempty$1 = Control$dMonad$dFree.monoidFree(Data$dMonoid.monoidUnit).mempty;
  return v => v1 => {
    if (v1.tag === "Nothing") { return mempty$1; }
    if (v1.tag === "Just") { return v(v1._1); }
    $runtime.fail();
  };
})();
const liftEffect = /* #__PURE__ */ (() => Halogen$dQuery$dHalogenM.monadEffectHalogenM(Effect$dAff.monadEffectAff).liftEffect)();
const GetCondition = value0 => $Query("GetCondition", value0);
const UpdateState = value0 => value1 => $Query("UpdateState", value0, value1);
const Updated = /* #__PURE__ */ $Output();
const UpdateConditionMode = value0 => $Action("UpdateConditionMode", value0);
const UpdateCardSelected = value0 => $Action("UpdateCardSelected", value0);
const UpdateCardCount = value0 => $Action("UpdateCardCount", value0);
const Receive = value0 => $Action("Receive", value0);
const SelectOnFocus = value0 => $Action("SelectOnFocus", value0);
const component = {
  initialState: v => ({cards: v, condition: {mode: TcgCalculator$dTypes.AtLeast, count: 0, cards: mempty}}),
  render: v => {
    const $0 = TcgCalculator$dTypes.filterCards(v.condition.cards)(v.cards);
    const countCards = sumBy(v$1 => v$1.count);
    const v1 = (() => {
      if (v.condition.mode === "AtLeast") {
        const max = countCards($0);
        return {min: min(1)(max), max};
      }
      if (v.condition.mode === "JustDraw") { return {min: 0, max: countCards($0)}; }
      if (v.condition.mode === "Remains") {
        const max = countCards($0);
        return {min: min(1)(max), max};
      }
      if (v.condition.mode === "JustRemains") { return {min: 0, max: countCards($0)}; }
      if (v.condition.mode === "Choice") {
        const max = $0.length;
        return {min: min(1)(max), max};
      }
      if (v.condition.mode === "LeftOne") {
        const max = $0.length;
        return {min: min(1)(max), max};
      }
      if (v.condition.mode === "LeftAll") {
        const max = $0.length;
        return {min: min(1)(max), max};
      }
      $runtime.fail();
    })();
    return Halogen$dVDom$dTypes.$VDom(
      "Elem",
      Data$dMaybe.Nothing,
      "div",
      [Halogen$dHTML$dProperties.class_("flex flex-wrap items-center justify-end")],
      [
        Halogen$dVDom$dTypes.$VDom(
          "Elem",
          Data$dMaybe.Nothing,
          "div",
          [Halogen$dHTML$dProperties.class_("w-48 grow rounded border border-gray-200 p-0.5")],
          [slot(Type$dProxy.Proxy)()(component1)(Data$dFunctor.arrayMap(card => ({key: card.id, value: card.name}))(v.cards))(UpdateCardSelected)]
        ),
        Halogen$dVDom$dTypes.$VDom(
          "Elem",
          Data$dMaybe.Nothing,
          "div",
          [Halogen$dHTML$dProperties.class_("flex items-center")],
          [
            Halogen$dVDom$dTypes.$VDom("Elem", Data$dMaybe.Nothing, "div", [Halogen$dHTML$dProperties.class_("mx-1")], [Halogen$dVDom$dTypes.$VDom("Text", "を")]),
            Halogen$dVDom$dTypes.$VDom(
              "Elem",
              Data$dMaybe.Nothing,
              "input",
              [
                Halogen$dHTML$dProperties.classes([
                  "w-12 appearance-none rounded border border-gray-400 bg-transparent p-1 text-right",
                  "transition ease-in-out hover:border-gray-500 focus:border-blue-600 focus:outline-none"
                ]),
                type_(DOM$dHTML$dIndexed$dInputType.InputNumber),
                Halogen$dHTML$dProperties.step(DOM$dHTML$dIndexed$dStepValue.$StepValue("Step", 1.0)),
                value(Data$dShow.showIntImpl(v.condition.count)),
                Halogen$dHTML$dProperties.min(Data$dInt.toNumber(v1.min)),
                Halogen$dHTML$dProperties.max(Data$dInt.toNumber(v1.max)),
                Halogen$dVDom$dDOM$dProp.$Prop("Handler", "focus", ev => Data$dMaybe.$Maybe("Just", Halogen$dQuery$dInput.$Input("Action", $Action("SelectOnFocus", ev)))),
                Halogen$dHTML$dEvents.addForeignPropHandler("change")("value")(Foreign.readString(Data$dIdentity.monadIdentity))(UpdateCardCount)
              ],
              []
            ),
            Halogen$dVDom$dTypes.$VDom(
              "Elem",
              Data$dMaybe.Nothing,
              "select",
              [
                Halogen$dHTML$dProperties.classes([
                  "w-full appearance-none rounded border border-gray-400 bg-transparent px-3 py-1",
                  "transition ease-in-out hover:border-gray-500 focus:border-blue-600 focus:outline-none"
                ]),
                value(TcgCalculator$dTypes.showConditionMode.show(v.condition.mode)),
                Halogen$dHTML$dEvents.addForeignPropHandler("change")("value")(Foreign.readString(Data$dIdentity.monadIdentity))(UpdateConditionMode)
              ],
              [
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "option",
                  [value(TcgCalculator$dTypes.showConditionMode.show(TcgCalculator$dTypes.AtLeast))],
                  [Halogen$dVDom$dTypes.$VDom("Text", "枚以上ドローする")]
                ),
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "option",
                  [value(TcgCalculator$dTypes.showConditionMode.show(TcgCalculator$dTypes.JustDraw))],
                  [Halogen$dVDom$dTypes.$VDom("Text", "枚ちょうどドローする")]
                ),
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "option",
                  [value(TcgCalculator$dTypes.showConditionMode.show(TcgCalculator$dTypes.Remains))],
                  [Halogen$dVDom$dTypes.$VDom("Text", "枚以上デッキに残す")]
                ),
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "option",
                  [value(TcgCalculator$dTypes.showConditionMode.show(TcgCalculator$dTypes.JustRemains))],
                  [Halogen$dVDom$dTypes.$VDom("Text", "枚ちょうどデッキに残す")]
                ),
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "option",
                  [value(TcgCalculator$dTypes.showConditionMode.show(TcgCalculator$dTypes.Choice))],
                  [Halogen$dVDom$dTypes.$VDom("Text", "種類以上ドローする")]
                ),
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "option",
                  [value(TcgCalculator$dTypes.showConditionMode.show(TcgCalculator$dTypes.LeftOne))],
                  [Halogen$dVDom$dTypes.$VDom("Text", "種類以上デッキに残す")]
                ),
                Halogen$dVDom$dTypes.$VDom(
                  "Elem",
                  Data$dMaybe.Nothing,
                  "option",
                  [value(TcgCalculator$dTypes.showConditionMode.show(TcgCalculator$dTypes.LeftAll))],
                  [Halogen$dVDom$dTypes.$VDom("Text", "種類以上ドローしない")]
                )
              ]
            )
          ]
        )
      ]
    );
  },
  eval: /* #__PURE__ */ Halogen$dComponent.mkEval({
    ...Halogen$dComponent.defaultEval,
    handleAction: v => {
      if (v.tag === "UpdateCardSelected") {
        const selected$p = fromFoldable(v._1);
        return Control$dMonad$dFree.$Free(
          $$get._1,
          Data$dCatList.$CatList(
            "CatCons",
            v1 => {
              const cards$p = TcgCalculator$dTypes.filterCards(selected$p)(v1.cards);
              const countCards = sumBy(v$1 => v$1.count);
              if (v1.condition.mode === "AtLeast") {
                const max = countCards(cards$p);
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(min(1)(max))(max)(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                if (!Data$dMap$dInternal.eqMap(Data$dUUID.eqUUID)(Data$dEq.eqUnit).eq(selected$p)(v1.condition.cards)) {
                  return Control$dMonad$dFree.$Free(
                    Control$dMonad$dFree.$FreeView(
                      "Bind",
                      Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                      x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                    ),
                    Data$dCatList.$CatList(
                      "CatCons",
                      () => Control$dMonad$dFree.$Free(
                        Control$dMonad$dFree.$FreeView(
                          "Bind",
                          Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                          x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                        ),
                        Data$dCatList.CatNil
                      ),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    )
                  );
                }
                return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil);
              }
              if (v1.condition.mode === "JustDraw") {
                const $0 = {
                  cards: v1.cards,
                  condition: {
                    mode: v1.condition.mode,
                    count: clamp(0)(countCards(cards$p))(v1.condition.count),
                    cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))
                  }
                };
                if (!Data$dMap$dInternal.eqMap(Data$dUUID.eqUUID)(Data$dEq.eqUnit).eq(selected$p)(v1.condition.cards)) {
                  return Control$dMonad$dFree.$Free(
                    Control$dMonad$dFree.$FreeView(
                      "Bind",
                      Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                      x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                    ),
                    Data$dCatList.$CatList(
                      "CatCons",
                      () => Control$dMonad$dFree.$Free(
                        Control$dMonad$dFree.$FreeView(
                          "Bind",
                          Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                          x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                        ),
                        Data$dCatList.CatNil
                      ),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    )
                  );
                }
                return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil);
              }
              if (v1.condition.mode === "Remains") {
                const max = countCards(cards$p);
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(min(1)(max))(max)(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                if (!Data$dMap$dInternal.eqMap(Data$dUUID.eqUUID)(Data$dEq.eqUnit).eq(selected$p)(v1.condition.cards)) {
                  return Control$dMonad$dFree.$Free(
                    Control$dMonad$dFree.$FreeView(
                      "Bind",
                      Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                      x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                    ),
                    Data$dCatList.$CatList(
                      "CatCons",
                      () => Control$dMonad$dFree.$Free(
                        Control$dMonad$dFree.$FreeView(
                          "Bind",
                          Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                          x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                        ),
                        Data$dCatList.CatNil
                      ),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    )
                  );
                }
                return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil);
              }
              if (v1.condition.mode === "JustRemains") {
                const $0 = {
                  cards: v1.cards,
                  condition: {
                    mode: v1.condition.mode,
                    count: clamp(0)(countCards(cards$p))(v1.condition.count),
                    cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))
                  }
                };
                if (!Data$dMap$dInternal.eqMap(Data$dUUID.eqUUID)(Data$dEq.eqUnit).eq(selected$p)(v1.condition.cards)) {
                  return Control$dMonad$dFree.$Free(
                    Control$dMonad$dFree.$FreeView(
                      "Bind",
                      Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                      x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                    ),
                    Data$dCatList.$CatList(
                      "CatCons",
                      () => Control$dMonad$dFree.$Free(
                        Control$dMonad$dFree.$FreeView(
                          "Bind",
                          Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                          x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                        ),
                        Data$dCatList.CatNil
                      ),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    )
                  );
                }
                return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil);
              }
              if (v1.condition.mode === "Choice") {
                const max = cards$p.length;
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(min(1)(max))(max)(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                if (!Data$dMap$dInternal.eqMap(Data$dUUID.eqUUID)(Data$dEq.eqUnit).eq(selected$p)(v1.condition.cards)) {
                  return Control$dMonad$dFree.$Free(
                    Control$dMonad$dFree.$FreeView(
                      "Bind",
                      Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                      x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                    ),
                    Data$dCatList.$CatList(
                      "CatCons",
                      () => Control$dMonad$dFree.$Free(
                        Control$dMonad$dFree.$FreeView(
                          "Bind",
                          Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                          x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                        ),
                        Data$dCatList.CatNil
                      ),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    )
                  );
                }
                return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil);
              }
              if (v1.condition.mode === "LeftOne") {
                const max = cards$p.length;
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(min(1)(max))(max)(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                if (!Data$dMap$dInternal.eqMap(Data$dUUID.eqUUID)(Data$dEq.eqUnit).eq(selected$p)(v1.condition.cards)) {
                  return Control$dMonad$dFree.$Free(
                    Control$dMonad$dFree.$FreeView(
                      "Bind",
                      Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                      x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                    ),
                    Data$dCatList.$CatList(
                      "CatCons",
                      () => Control$dMonad$dFree.$Free(
                        Control$dMonad$dFree.$FreeView(
                          "Bind",
                          Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                          x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                        ),
                        Data$dCatList.CatNil
                      ),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    )
                  );
                }
                return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil);
              }
              if (v1.condition.mode === "LeftAll") {
                const max = cards$p.length;
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(min(1)(max))(max)(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                if (!Data$dMap$dInternal.eqMap(Data$dUUID.eqUUID)(Data$dEq.eqUnit).eq(selected$p)(v1.condition.cards)) {
                  return Control$dMonad$dFree.$Free(
                    Control$dMonad$dFree.$FreeView(
                      "Bind",
                      Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                      x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                    ),
                    Data$dCatList.$CatList(
                      "CatCons",
                      () => Control$dMonad$dFree.$Free(
                        Control$dMonad$dFree.$FreeView(
                          "Bind",
                          Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                          x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                        ),
                        Data$dCatList.CatNil
                      ),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    )
                  );
                }
                return Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil);
              }
              $runtime.fail();
            },
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        );
      }
      if (v.tag === "UpdateConditionMode") {
        return foldMap1(mode$p => Control$dMonad$dFree.$Free(
          $$get._1,
          Data$dCatList.$CatList(
            "CatCons",
            v1 => {
              const cards$p = TcgCalculator$dTypes.filterCards(v1.condition.cards)(v1.cards);
              const countCards = sumBy(v$1 => v$1.count);
              if (mode$p === "AtLeast") {
                const max = countCards(cards$p);
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: mode$p, count: clamp(min(1)(max))(max)(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (mode$p === "JustDraw") {
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: mode$p, count: clamp(0)(countCards(cards$p))(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (mode$p === "Remains") {
                const max = countCards(cards$p);
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: mode$p, count: clamp(min(1)(max))(max)(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (mode$p === "JustRemains") {
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: mode$p, count: clamp(0)(countCards(cards$p))(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (mode$p === "Choice") {
                const max = cards$p.length;
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: mode$p, count: clamp(min(1)(max))(max)(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (mode$p === "LeftOne") {
                const max = cards$p.length;
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: mode$p, count: clamp(min(1)(max))(max)(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (mode$p === "LeftAll") {
                const max = cards$p.length;
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: mode$p, count: clamp(min(1)(max))(max)(v1.condition.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              $runtime.fail();
            },
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        ))((() => {
          if (v._1 === "AtLeast") { return Data$dMaybe.$Maybe("Just", TcgCalculator$dTypes.AtLeast); }
          if (v._1 === "JustDraw") { return Data$dMaybe.$Maybe("Just", TcgCalculator$dTypes.JustDraw); }
          if (v._1 === "Remains") { return Data$dMaybe.$Maybe("Just", TcgCalculator$dTypes.Remains); }
          if (v._1 === "JustRemains") { return Data$dMaybe.$Maybe("Just", TcgCalculator$dTypes.JustRemains); }
          if (v._1 === "Choice") { return Data$dMaybe.$Maybe("Just", TcgCalculator$dTypes.Choice); }
          if (v._1 === "LeftOne") { return Data$dMaybe.$Maybe("Just", TcgCalculator$dTypes.LeftOne); }
          if (v._1 === "LeftAll") { return Data$dMaybe.$Maybe("Just", TcgCalculator$dTypes.LeftAll); }
          return Data$dMaybe.Nothing;
        })());
      }
      if (v.tag === "UpdateCardCount") {
        return foldMap1(count$p => Control$dMonad$dFree.$Free(
          $$get._1,
          Data$dCatList.$CatList(
            "CatCons",
            v1 => {
              const cards$p = TcgCalculator$dTypes.filterCards(v1.condition.cards)(v1.cards);
              const countCards = sumBy(v$1 => v$1.count);
              if (v1.condition.mode === "AtLeast") {
                const max = countCards(cards$p);
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(min(1)(max))(max)(count$p), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (v1.condition.mode === "JustDraw") {
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(0)(countCards(cards$p))(count$p), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (v1.condition.mode === "Remains") {
                const max = countCards(cards$p);
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(min(1)(max))(max)(count$p), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (v1.condition.mode === "JustRemains") {
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(0)(countCards(cards$p))(count$p), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (v1.condition.mode === "Choice") {
                const max = cards$p.length;
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(min(1)(max))(max)(count$p), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (v1.condition.mode === "LeftOne") {
                const max = cards$p.length;
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(min(1)(max))(max)(count$p), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if (v1.condition.mode === "LeftAll") {
                const max = cards$p.length;
                const $0 = {
                  cards: v1.cards,
                  condition: {mode: v1.condition.mode, count: clamp(min(1)(max))(max)(count$p), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $0)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("Raise", Updated, undefined),
                        x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.CatNil
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              $runtime.fail();
            },
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        ))(Data$dInt.fromString(v._1));
      }
      if (v.tag === "Receive") {
        const $0 = v._1;
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.condition, s)),
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList(
            "CatCons",
            v1 => {
              const cards$p = TcgCalculator$dTypes.filterCards(v1.cards)($0);
              const countCards = sumBy(v$1 => v$1.count);
              if (v1.mode === "AtLeast") {
                const max = countCards(cards$p);
                const $1 = {cards: $0, condition: {mode: v1.mode, count: clamp(min(1)(max))(max)(v1.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $1)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                );
              }
              if (v1.mode === "JustDraw") {
                const $1 = {
                  cards: $0,
                  condition: {mode: v1.mode, count: clamp(0)(countCards(cards$p))(v1.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $1)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                );
              }
              if (v1.mode === "Remains") {
                const max = countCards(cards$p);
                const $1 = {cards: $0, condition: {mode: v1.mode, count: clamp(min(1)(max))(max)(v1.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $1)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                );
              }
              if (v1.mode === "JustRemains") {
                const $1 = {
                  cards: $0,
                  condition: {mode: v1.mode, count: clamp(0)(countCards(cards$p))(v1.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}
                };
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $1)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                );
              }
              if (v1.mode === "Choice") {
                const max = cards$p.length;
                const $1 = {cards: $0, condition: {mode: v1.mode, count: clamp(min(1)(max))(max)(v1.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $1)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                );
              }
              if (v1.mode === "LeftOne") {
                const max = cards$p.length;
                const $1 = {cards: $0, condition: {mode: v1.mode, count: clamp(min(1)(max))(max)(v1.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $1)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                );
              }
              if (v1.mode === "LeftAll") {
                const max = cards$p.length;
                const $1 = {cards: $0, condition: {mode: v1.mode, count: clamp(min(1)(max))(max)(v1.count), cards: fromFoldable(Data$dFunctor.arrayMap(v1$1 => v1$1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v$1 => Data$dTuple.$Tuple(undefined, $1)),
                    x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.CatNil
                );
              }
              $runtime.fail();
            },
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          )
        );
      }
      if (v.tag === "SelectOnFocus") {
        return liftEffect((() => {
          const $0 = Data$dNullable.nullable(Web$dEvent$dEvent._target(v._1), Data$dMaybe.Nothing, Data$dMaybe.Just);
          const $1 = (() => {
            if ($0.tag === "Just") { return Web$dInternal$dFFI._unsafeReadProtoTagged(Data$dMaybe.Nothing, Data$dMaybe.Just, "HTMLInputElement", $0._1); }
            if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
            $runtime.fail();
          })();
          if ($1.tag === "Nothing") { return () => {}; }
          if ($1.tag === "Just") { return Web$dHTML$dHTMLInputElement.select($1._1); }
          $runtime.fail();
        })());
      }
      $runtime.fail();
    },
    handleQuery: x => {
      if (x.tag === "GetCondition") {
        const $0 = gets(v1 => v1.condition);
        return Control$dMonad$dFree.$Free(
          $0._1,
          (() => {
            if ($0._2.tag === "CatNil") {
              return Data$dCatList.$CatList(
                "CatCons",
                x$1 => Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView("Return", x$1.tag === "Just" ? Data$dMaybe.$Maybe("Just", x._1(x$1._1)) : Data$dMaybe.Nothing),
                  Data$dCatList.CatNil
                ),
                Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
              );
            }
            if ($0._2.tag === "CatCons") {
              return Data$dCatList.$CatList(
                "CatCons",
                $0._2._1,
                Data$dCatQueue.$CatQueue(
                  $0._2._2._1,
                  Data$dList$dTypes.$List(
                    "Cons",
                    Data$dCatList.$CatList(
                      "CatCons",
                      x$1 => Control$dMonad$dFree.$Free(
                        Control$dMonad$dFree.$FreeView("Return", x$1.tag === "Just" ? Data$dMaybe.$Maybe("Just", x._1(x$1._1)) : Data$dMaybe.Nothing),
                        Data$dCatList.CatNil
                      ),
                      Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                    ),
                    $0._2._2._2
                  )
                )
              );
            }
            $runtime.fail();
          })()
        );
      }
      if (x.tag === "UpdateState") {
        const $0 = x._2;
        const $1 = x._1.count;
        const $2 = x._1.mode;
        const $3 = x._1.cards;
        return Control$dMonad$dFree.$Free(
          Control$dMonad$dFree.$FreeView(
            "Bind",
            Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.cards, s)),
            x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
          ),
          Data$dCatList.$CatList(
            "CatCons",
            cards => {
              const cards$p = TcgCalculator$dTypes.filterCards($3)(cards);
              const countCards = sumBy(v => v.count);
              if ($2 === "AtLeast") {
                const max = countCards(cards$p);
                const $4 = {cards, condition: {mode: $2, count: clamp(min(1)(max))(max)($1), cards: fromFoldable(Data$dFunctor.arrayMap(v1 => v1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v => Data$dTuple.$Tuple(undefined, $4)),
                    x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.condition, s)),
                        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.$CatList(
                        "CatCons",
                        v1 => {
                          const $5 = v1.cards;
                          const $6 = tell(Type$dProxy.Proxy)()(App$dSelector.SetItems(Data$dFunctor.arrayMap(v2 => ({key: v2.id, value: v2.name, selected: member(v2.id)($5)}))(cards)));
                          return Control$dMonad$dFree.$Free(
                            $6._1,
                            (() => {
                              if ($6._2.tag === "CatNil") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                );
                              }
                              if ($6._2.tag === "CatCons") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  $6._2._1,
                                  Data$dCatQueue.$CatQueue(
                                    $6._2._2._1,
                                    Data$dList$dTypes.$List(
                                      "Cons",
                                      Data$dCatList.$CatList(
                                        "CatCons",
                                        () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                      ),
                                      $6._2._2._2
                                    )
                                  )
                                );
                              }
                              $runtime.fail();
                            })()
                          );
                        },
                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                      )
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if ($2 === "JustDraw") {
                const $4 = {cards, condition: {mode: $2, count: clamp(0)(countCards(cards$p))($1), cards: fromFoldable(Data$dFunctor.arrayMap(v1 => v1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v => Data$dTuple.$Tuple(undefined, $4)),
                    x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.condition, s)),
                        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.$CatList(
                        "CatCons",
                        v1 => {
                          const $5 = v1.cards;
                          const $6 = tell(Type$dProxy.Proxy)()(App$dSelector.SetItems(Data$dFunctor.arrayMap(v2 => ({key: v2.id, value: v2.name, selected: member(v2.id)($5)}))(cards)));
                          return Control$dMonad$dFree.$Free(
                            $6._1,
                            (() => {
                              if ($6._2.tag === "CatNil") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                );
                              }
                              if ($6._2.tag === "CatCons") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  $6._2._1,
                                  Data$dCatQueue.$CatQueue(
                                    $6._2._2._1,
                                    Data$dList$dTypes.$List(
                                      "Cons",
                                      Data$dCatList.$CatList(
                                        "CatCons",
                                        () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                      ),
                                      $6._2._2._2
                                    )
                                  )
                                );
                              }
                              $runtime.fail();
                            })()
                          );
                        },
                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                      )
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if ($2 === "Remains") {
                const max = countCards(cards$p);
                const $4 = {cards, condition: {mode: $2, count: clamp(min(1)(max))(max)($1), cards: fromFoldable(Data$dFunctor.arrayMap(v1 => v1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v => Data$dTuple.$Tuple(undefined, $4)),
                    x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.condition, s)),
                        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.$CatList(
                        "CatCons",
                        v1 => {
                          const $5 = v1.cards;
                          const $6 = tell(Type$dProxy.Proxy)()(App$dSelector.SetItems(Data$dFunctor.arrayMap(v2 => ({key: v2.id, value: v2.name, selected: member(v2.id)($5)}))(cards)));
                          return Control$dMonad$dFree.$Free(
                            $6._1,
                            (() => {
                              if ($6._2.tag === "CatNil") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                );
                              }
                              if ($6._2.tag === "CatCons") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  $6._2._1,
                                  Data$dCatQueue.$CatQueue(
                                    $6._2._2._1,
                                    Data$dList$dTypes.$List(
                                      "Cons",
                                      Data$dCatList.$CatList(
                                        "CatCons",
                                        () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                      ),
                                      $6._2._2._2
                                    )
                                  )
                                );
                              }
                              $runtime.fail();
                            })()
                          );
                        },
                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                      )
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if ($2 === "JustRemains") {
                const $4 = {cards, condition: {mode: $2, count: clamp(0)(countCards(cards$p))($1), cards: fromFoldable(Data$dFunctor.arrayMap(v1 => v1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v => Data$dTuple.$Tuple(undefined, $4)),
                    x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.condition, s)),
                        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.$CatList(
                        "CatCons",
                        v1 => {
                          const $5 = v1.cards;
                          const $6 = tell(Type$dProxy.Proxy)()(App$dSelector.SetItems(Data$dFunctor.arrayMap(v2 => ({key: v2.id, value: v2.name, selected: member(v2.id)($5)}))(cards)));
                          return Control$dMonad$dFree.$Free(
                            $6._1,
                            (() => {
                              if ($6._2.tag === "CatNil") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                );
                              }
                              if ($6._2.tag === "CatCons") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  $6._2._1,
                                  Data$dCatQueue.$CatQueue(
                                    $6._2._2._1,
                                    Data$dList$dTypes.$List(
                                      "Cons",
                                      Data$dCatList.$CatList(
                                        "CatCons",
                                        () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                      ),
                                      $6._2._2._2
                                    )
                                  )
                                );
                              }
                              $runtime.fail();
                            })()
                          );
                        },
                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                      )
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if ($2 === "Choice") {
                const max = cards$p.length;
                const $4 = {cards, condition: {mode: $2, count: clamp(min(1)(max))(max)($1), cards: fromFoldable(Data$dFunctor.arrayMap(v1 => v1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v => Data$dTuple.$Tuple(undefined, $4)),
                    x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.condition, s)),
                        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.$CatList(
                        "CatCons",
                        v1 => {
                          const $5 = v1.cards;
                          const $6 = tell(Type$dProxy.Proxy)()(App$dSelector.SetItems(Data$dFunctor.arrayMap(v2 => ({key: v2.id, value: v2.name, selected: member(v2.id)($5)}))(cards)));
                          return Control$dMonad$dFree.$Free(
                            $6._1,
                            (() => {
                              if ($6._2.tag === "CatNil") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                );
                              }
                              if ($6._2.tag === "CatCons") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  $6._2._1,
                                  Data$dCatQueue.$CatQueue(
                                    $6._2._2._1,
                                    Data$dList$dTypes.$List(
                                      "Cons",
                                      Data$dCatList.$CatList(
                                        "CatCons",
                                        () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                      ),
                                      $6._2._2._2
                                    )
                                  )
                                );
                              }
                              $runtime.fail();
                            })()
                          );
                        },
                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                      )
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if ($2 === "LeftOne") {
                const max = cards$p.length;
                const $4 = {cards, condition: {mode: $2, count: clamp(min(1)(max))(max)($1), cards: fromFoldable(Data$dFunctor.arrayMap(v1 => v1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v => Data$dTuple.$Tuple(undefined, $4)),
                    x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.condition, s)),
                        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.$CatList(
                        "CatCons",
                        v1 => {
                          const $5 = v1.cards;
                          const $6 = tell(Type$dProxy.Proxy)()(App$dSelector.SetItems(Data$dFunctor.arrayMap(v2 => ({key: v2.id, value: v2.name, selected: member(v2.id)($5)}))(cards)));
                          return Control$dMonad$dFree.$Free(
                            $6._1,
                            (() => {
                              if ($6._2.tag === "CatNil") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                );
                              }
                              if ($6._2.tag === "CatCons") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  $6._2._1,
                                  Data$dCatQueue.$CatQueue(
                                    $6._2._2._1,
                                    Data$dList$dTypes.$List(
                                      "Cons",
                                      Data$dCatList.$CatList(
                                        "CatCons",
                                        () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                      ),
                                      $6._2._2._2
                                    )
                                  )
                                );
                              }
                              $runtime.fail();
                            })()
                          );
                        },
                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                      )
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              if ($2 === "LeftAll") {
                const max = cards$p.length;
                const $4 = {cards, condition: {mode: $2, count: clamp(min(1)(max))(max)($1), cards: fromFoldable(Data$dFunctor.arrayMap(v1 => v1.id)(cards$p))}};
                return Control$dMonad$dFree.$Free(
                  Control$dMonad$dFree.$FreeView(
                    "Bind",
                    Halogen$dQuery$dHalogenM.$HalogenF("State", v => Data$dTuple.$Tuple(undefined, $4)),
                    x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                  ),
                  Data$dCatList.$CatList(
                    "CatCons",
                    () => Control$dMonad$dFree.$Free(
                      Control$dMonad$dFree.$FreeView(
                        "Bind",
                        Halogen$dQuery$dHalogenM.$HalogenF("State", s => Data$dTuple.$Tuple(s.condition, s)),
                        x$1 => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", x$1), Data$dCatList.CatNil)
                      ),
                      Data$dCatList.$CatList(
                        "CatCons",
                        v1 => {
                          const $5 = v1.cards;
                          const $6 = tell(Type$dProxy.Proxy)()(App$dSelector.SetItems(Data$dFunctor.arrayMap(v2 => ({key: v2.id, value: v2.name, selected: member(v2.id)($5)}))(cards)));
                          return Control$dMonad$dFree.$Free(
                            $6._1,
                            (() => {
                              if ($6._2.tag === "CatNil") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                );
                              }
                              if ($6._2.tag === "CatCons") {
                                return Data$dCatList.$CatList(
                                  "CatCons",
                                  $6._2._1,
                                  Data$dCatQueue.$CatQueue(
                                    $6._2._2._1,
                                    Data$dList$dTypes.$List(
                                      "Cons",
                                      Data$dCatList.$CatList(
                                        "CatCons",
                                        () => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", $0), Data$dCatList.CatNil),
                                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                                      ),
                                      $6._2._2._2
                                    )
                                  )
                                );
                              }
                              $runtime.fail();
                            })()
                          );
                        },
                        Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                      )
                    ),
                    Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                  )
                );
              }
              $runtime.fail();
            },
            Data$dCatQueue.$CatQueue(
              Data$dList$dTypes.Nil,
              Data$dList$dTypes.$List(
                "Cons",
                Data$dCatList.$CatList(
                  "CatCons",
                  a$p => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", Data$dMaybe.$Maybe("Just", a$p)), Data$dCatList.CatNil),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                ),
                Data$dList$dTypes.Nil
              )
            )
          )
        );
      }
      $runtime.fail();
    },
    receive: x => Data$dMaybe.$Maybe("Just", $Action("Receive", x))
  })
};
export {
  $Action,
  $Output,
  $Query,
  GetCondition,
  Receive,
  SelectOnFocus,
  UpdateCardCount,
  UpdateCardSelected,
  UpdateConditionMode,
  UpdateState,
  Updated,
  clamp,
  component,
  component1,
  foldMap1,
  fromFoldable,
  $$get as get,
  gets,
  liftEffect,
  member,
  mempty,
  min,
  selectorIsSymbol,
  slot,
  sumBy,
  tell,
  type_,
  value
};
